import { useEffect } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@cocoonspace/ui/components/dialog'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'

import { useAuth } from '~/providers/auth-provider'
import { ForgottenPassForm } from './forgotten-pass-form'
import { LoginForm } from './login-form'
import { RegisterForm } from './register-form'

export const AuthDialog = () => {
	const { t } = useLingui()
	const {
		isAuth,
		isAuthDialogOpen,
		setIsAuthDialogOpen,
		authDialogActiveTab,
		authErrorMsg,
	} = useAuth()

	useEffect(() => {
		if (isAuth) {
			setIsAuthDialogOpen(false)
		}
	}, [isAuth, setIsAuthDialogOpen])

	return (
		<Dialog
			open={isAuthDialogOpen}
			onOpenChange={setIsAuthDialogOpen}
		>
			<DialogContent
				className={cn(
					'max-w-[385px] pb-3',
					['login', 'register'].includes(authDialogActiveTab) && 'px-0',
				)}
				hideCloseBtn
			>
				<DialogHeader
					className={cn(
						['login', 'register'].includes(authDialogActiveTab) && 'px-6',
					)}
				>
					<DialogTitle>
						{authDialogActiveTab === 'login' && t`Se connecter`}
						{authDialogActiveTab === 'register' && t`S'inscrire`}
						{authDialogActiveTab === 'forgottenPass' && t`Mot de passe oublié`}
					</DialogTitle>
				</DialogHeader>

				{!!authErrorMsg && (
					<p className='text-primary mb-4 px-6 text-sm'>{authErrorMsg}</p>
				)}

				{authDialogActiveTab === 'login' && <LoginForm />}
				{authDialogActiveTab === 'register' && <RegisterForm />}
				{authDialogActiveTab === 'forgottenPass' && <ForgottenPassForm />}
			</DialogContent>
		</Dialog>
	)
}
